// Module
var code = `<div class="svc-question__dropdown-choices--wrapper">
  <div>
    <div class="svc-question__dropdown-choices">
      <!-- ko foreach: { data: getRenderedItems(), as: 'item' }  -->
      <div data-bind="css: \$parent.getChoiceCss()">
        <!-- ko component: { name: question.getItemValueWrapperComponentName(item), params: { componentData:  question.getItemValueWrapperComponentData(item), templateData: { name: \$parent.itemComponent, data: item } } } -->
        <!-- /ko -->
      </div>
      <!-- /ko -->
    </div>
    <!-- ko if: needToCollapse -->
    <svc-action-button params="text: getButtonText(), click: switchCollapse, allowBubble: true">
    </svc-action-button>
    <!-- /ko -->
  </div>
</div>`;
// Exports
export default code;